const COMMENTS = [
  {
    dishId: 0,
    id: 0,
    rating: 5,
    comment: "One of the best bergure I have ever eat.",
    author: "Shanto",
    date: "2019-10-",
  },
  {
    dishId: 0,
    id: 1,
    rating: 4,
    comment: "Awesome bergure I have ever eat.",
    author: "Mamun",
    date: "2019-10-",
  },
  {
    dishId: 0,
    id: 2,
    rating: 4,
    comment:
      "Sends anyone to heaven, I wish I could get my mother in low to eat this.",
    author: "Karim",
    date: "2017-12",
  },
  {
    dishId: 0,
    id: 3,
    rating: 3,
    comment: "Eat it, just eat it!",
    author: "Moinul",
    date: "2019-2",
  },
  {
    dishId: 0,
    id: 4,
    rating: 4,
    comment: "Ultimate, Reaching for the stars!",
    author: "Rahat",
    date: "2017-6",
  },
  {
    dishId: 0,
    id: 5,
    rating: 2,
    comment: "It's your birthday, we're gonna party!",
    author: "Rnoy",
    date: "2019-4",
  },
];
export default COMMENTS;
